import { foldTurkish, normalizeCountryName } from '../constants/countries';

/**
 * Bir ülkenin "seçili başvuru" haline gelirken kullandığı KANONİK anahtarı üretir.
 *
 * `state.selectedCountry` uygulamanın her yerinde ülkenin **DB slug'ı** varsayılır:
 *   - `/api/countries/{slug}/standard-documents` (+ purpose/education) uçları,
 *   - ProfilePage'in Ticari / Eğitim açma listeleri ('cekya', 'italya', ...),
 *   - localStorage anahtarları, ödenmiş-ülke eşleşmesi, sohbet country_slug'ı.
 *
 * MainPage kartı zaten DB kaydını elinde tuttuğu için `country.slug`'ı geçiyordu; welcome
 * akışı ise sunucudan yalnız GÖRÜNEN AD ("Çekya") aldığından `name.toLowerCase()` ile slug
 * üretmeye çalışıyordu — Türkçe karakterli her ülkede bozuk anahtar ('çekya' ≠ 'cekya',
 * 'İtalya'.toLowerCase() ise 'i̇talya' yani i + U+0307). Ad→anahtar dönüşümü ARTIK TEK YERDE:
 * aktif ülke listesindeki gerçek kayıt. Paralel bir ad→anahtar tablosu EKLEMEYİN — bkz.
 * src/constants/countries.jsx başındaki "Çekya vs Çek Cumhuriyeti" notu.
 */

/**
 * Aktif ülke listesinde (countriesAPI.getActiveCountries) adı VEYA slug'ı verilen değere
 * eşleşen kaydı bulur. Karşılaştırma iki tarafta da aynı `toLowerCase()` ile yapıldığı için
 * Türkçe karakterler sorun olmaz. Eşleşme yoksa `undefined`.
 */
export function findActiveCountry(countries, nameOrSlug) {
  const key = String(nameOrSlug || '').toLowerCase().trim();
  if (!key) return undefined;
  return (countries || []).find(
    (c) => c.name?.toLowerCase() === key || c.slug?.toLowerCase() === key
  );
}

/**
 * Görünen ad (veya slug) → kanonik DB slug'ı.
 *
 * Liste yüklenememişse (ağ hatası) ülkeyi kaybetmemek için ASCII'ye katlanmış ad'a düşer:
 * normalizeCountryName Türkçe karakterleri çevirir ve ilk kelimeyi alır — welcome'ın önerdiği
 * 28 ülkenin tamamında DB slug'ının aynısını verir ('Çekya'→'cekya', 'İsviçre'→'isvicre').
 * Ham `toLowerCase()` ise ASLA kullanılmamalı: bozuk anahtar üretir.
 */
export function resolveCountrySlug(countries, nameOrSlug) {
  const match = findActiveCountry(countries, nameOrSlug);
  return match?.slug || normalizeCountryName(nameOrSlug);
}

/**
 * Aktif ülke kaydından `SET_SELECTED_VISA_APPLICATION` yükü. Kayıt yoksa (katalog gelmedi)
 * görünen adla yetinilir; vize tipi ve foto zenginleşmez.
 */
export function toSelectedVisaApplication(country, fallbackName, now = new Date()) {
  return {
    country: country?.name || fallbackName,
    type: country?.visa_type || 'Turistik Vize',
    image: country?.photo_url,
    applicationDate: now.toISOString(),
    status: 'Başlatıldı',
  };
}

/** Türkçe kurallı küçük harf (ad karşılaştırma). 'İ' → 'i', 'I' → 'ı'. */
export const trLower = (text) => (text || '').toLocaleLowerCase('tr');

/**
 * Arama anahtarı: Türkçe harfler ASCII'ye katlanır, sonra küçük harf. Türkçe klavyesi olmayan
 * kullanıcı 'cek' yazınca Çekya'yı, 'ITAL' yazınca İtalya'yı bulsun. Katlama küçük harften
 * ÖNCE: tr küçük harfi 'I'yı 'ı' yapar, ASCII aramayı kaçırırdı.
 */
export const searchKey = (text) => foldTurkish(text || '').toLowerCase().trim();
